module.exports = __webpack_public_path__ + "static/media/header-reward6f9f1e514537fee931e3f613c2b96024.webp";